import { useCatalogProductIdParams } from '../hooks/useCatalogProductIdParams';
import { usePdpBaseInfo } from './usePdpBaseInfo';

export const useDescriptionBannerGroupVisibility = () => {
  const { product } = usePdpBaseInfo(useCatalogProductIdParams());

  const shouldRender =
    Boolean(product.description_top_banner) ||
    Boolean(product.vertical_page_banner) ||
    Boolean(product.external_product_url);

  return { shouldRender };
};
